/* eslint no-useless-escape: 0 */

const getUrlProps = (url) => {
  const match = url.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
  return match
    ? {
      url,
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7],
    }
    : false;
};

const testDecimalPlaces = (value, places) => {
  const regex = new RegExp(`^[0-9]*(?:.[0-9]{0,${places}})?$`);
  return regex.test(value);
};

// test time format for HH:MM or H:MM
const testTimeFormat = (value) => {
  const regex = new RegExp('^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$');
  return regex.test(value);
};

const buildUrl = (url, params, encoded = true) => {
  const isServiceObject = !!(typeof url === 'object' && url.url);
  let query = isServiceObject ? url.url : url;
  const cleanParams = { ...params };
  Object.keys(cleanParams).forEach((key) => {
    if (cleanParams[key] === undefined) {
      delete cleanParams[key];
    }
  });

  // query += query.indexOf('?') < 1 ? '?' : '&';
  query += '?';
  query += Object.keys(cleanParams)
    .filter(key => cleanParams[key] !== undefined)
    .map(key => `${key}=${encoded ? encodeURIComponent(cleanParams[key]) : cleanParams[key]}`)
    .join('&');

  return isServiceObject ? { ...url, ...{ url: query } } : query;
};

const getObjProp = (path = '', obj = {}) => path.split('.').reduce((o, key) => (o && o[key] ? o[key] : null), obj);

const numberWithCommas = val => val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

/*
  source from older version of underscorejs.org without dependencies
  as posted on https://davidwalsh.name/javascript-debounce-function
*/
function debounce(func, wait, immediate) {
  let timeout;

  return () => {
    /* Legacy code in case of translation error */
    // const context = this,
    //   args = arguments;
    const context = this;
    const args = this.arguments;

    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

const padArray = (arr, len, fill) => arr.concat(Array(len).fill(fill)).slice(0, len);

const isFloat = n => Number(n) === n && n % 1 !== 0;

function dynamicNextLineString(str = '', maxLength = 0) {
  let buff = '';
  const numOfLines = Math.floor(str.length / maxLength);

  for (let i = 0; i < numOfLines + 1; i += 1) {
    buff += str.substr(i * maxLength, maxLength);
    if (i !== numOfLines) {
      buff += '\n';
    }
  }
  return buff;
}

export {
  getUrlProps,
  buildUrl,
  testDecimalPlaces,
  testTimeFormat,
  getObjProp,
  numberWithCommas,
  debounce,
  padArray,
  isFloat,
  dynamicNextLineString,
};



// WEBPACK FOOTER //
// ./src/helpers/misc.js